import { styled } from '@mui/material';
import { forwardRef, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

const LogoWrapper = styled(Link)(({ theme }) => ({
  [`& `]: {
    color: theme.palette.text.primary,
    width: '281px',
    height: '130px'
  }
}));

interface Props {
  ref: ReactNode;
}

export const FullLogo = forwardRef<HTMLAnchorElement, Props>((props, ref) => (
  <LogoWrapper
    to="/"
    {...props}
    style={{
      width: '181px',
      display: 'block',
      margin: '0 auto'
    }}
    ref={ref}
  >
    <img src="/static/images/logo/full_logo.svg" width="100%" alt="logo" />
  </LogoWrapper>
));
